export interface ExecuteResultDto {
    status: 'success' | 'error' | 'warning' | 'info';
    message: string;
    detail: string;
}

export const ExecuteResultStatus = {
    Success: 'success',
    Error: 'error',
    Warning: 'warning',
    Info: 'info'
};
